import React from "react";

import type { LobbyPlayer } from "../shared";

export function Lobby({
	code,
	players,
	localPlayerId,
	onReady,
}: {
	code: string;
	players: LobbyPlayer[];
	localPlayerId: string;
	onReady: () => void;
}) {
	const local = players.find((p) => p.playerId === localPlayerId);
	return (
		<div className="App">
			<h1>RK Beach Rampage</h1>
			<p>
				Room <b>{code}</b> — share this link:{" "}
				<code>
					{location.origin}/room/{code}
				</code>
			</p>
			<ul className="lobby-roster">
				{players.map((p) => (
					<li key={p.playerId}>
						{p.name}
						{p.playerId === localPlayerId ? " (you)" : ""} — {p.ready ? "Ready" : "Waiting"}
					</li>
				))}
			</ul>
			<button onClick={onReady} disabled={local?.ready}>
				{local?.ready ? "Waiting for opponent…" : "Ready"}
			</button>
		</div>
	);
}
